import { StateService } from './../../services/state.service';
import { Admin } from 'sharedTypes/admin';
import { FirebaseService } from './../../services/firebase.service';
import { AuthService } from './../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-home',
    standalone: false,
    template: `
        <div style="display: flex; flex-direction: column; height: 100%; width: 100%">
            <!--<div
        style="flex-direction: column; cursor: pointer; display: flex; width: 450px; height: 60px; justify-content: center; align-items: center; border-radius: 5px; background-color: white; color:#29b6f6;">
        <div style="display:flex; flex-direction: row; justify-content: center; align-items: center; flex-grow: 1">
        <img src="assets/hero.png" alt="hero" style="height: 40px;">
        <span style="font-size:   40px">P</span>
        <mat-icon
          style="transform: rotate(90deg); margin-right: -2px; font-size: 40px; height: 40px; width: 40px; margin-left: -4px;margin-top: 2px;">
          support_agent</mat-icon>
          <span style="font-size: 40px; margin-right: 20px">R SUPPORT</span>
          </div>
          <h2 *ngIf="!authService.isAuthenticated()">Nicht angemeldet</h2>
          
    
      </div>-->
            <!--<h1 (click)="setUserClaims()" >Set</h1>-->

            <div
                *ngIf="authService.isAuthenticated()"
                style="display: flex; width: 100%; overflow: auto; padding: 16px; flex-direction: column;"
            >
                <div>
                    <small>Interne Neuigkeiten</small>
                </div>

                <div
                    [innerHtml]="
                        firebaseService.getLines((stateService.sharedSettings | async)?.teamNews || 'Keine Neuigkeiten')
                            | safehtml
                    "
                ></div>
            </div>
            <div
                *ngIf="authService.isAuthenticated()"
                style="display: flex; width: 100%; max-height: calc( 100% - 300px); height: calc( 100% - 300px); overflow: auto; ; flex-direction: column;"
            >
                <app-tickets [filter]="'my'"></app-tickets>
            </div>
            <div class="footer">
                <div class="col-12 signature" style="text-align: right">
                    PDR.Support
                    <span
                        >{{ version }} <span *ngIf="!isProd">[{{ envName }}]</span></span
                    >
                </div>
            </div>
        </div>

        <!--<h1 (click)="adminToken()" >tok</h1>-->
        <!--<h1 (click)="allPhones()" >Phones</h1>-->
        <!--<h1 (click)="importAll()" >Alle</h1>
<h1 (click)="requestImportAllUsers()" >Users</h1>
<h1 (click)="importZoho()" >Zoho</h1>-->
        <!--<h1 (click)="test()" >test</h1>-->
        <!--<h1 (click)="local()">local</h1>-->
    `,
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
    isProd = environment.production;
    envName = environment.envName;
    version = environment.versions.app;
    constructor(
        public authService: AuthService,
        public stateService: StateService,
        public firebaseService: FirebaseService,
    ) {}

    testClientCreate() {
        this.firebaseService.requestCreateOrUpdateClient('5hk1PJsnL3aOYEkSLZvlYW9c78A3');
    }
    importAll() {
        this.firebaseService.requestImportAllAccounts();
    }
    adminToken() {
        // this.firebaseService.adminToken();
        // this.authService.loginWithToken('eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJodHRwczovL2lkZW50aXR5dG9vbGtpdC5nb29nbGVhcGlzLmNvbS9nb29nbGUuaWRlbnRpdHkuaWRlbnRpdHl0b29sa2l0LnYxLklkZW50aXR5VG9vbGtpdCIsImlhdCI6MTYyNzMwMjcxMiwiZXhwIjoxNjI3MzA2MzEyLCJpc3MiOiJmaXJlYmFzZS1hZG1pbnNkay1naGVyY0BwZHItdGVhbS5pYW0uZ3NlcnZpY2VhY2NvdW50LmNvbSIsInN1YiI6ImZpcmViYXNlLWFkbWluc2RrLWdoZXJjQHBkci10ZWFtLmlhbS5nc2VydmljZWFjY291bnQuY29tIiwidWlkIjoiSG9GUWF0ZnBzSGN3RFFkbnVRUG5oQk9zTklsMSJ9.Apoiqmauku3N84w25kM9rqjTmkktrhyCSOzdflZxy5Ai1aHbYtImtmmC1q4PbiLJcBSthD1W-VCjsoh9j16wIDMlxv354UjYxyVtRSVmbjK0NO9W6Z2ukyNq5N4R3FkfHeQZOAr6JWDcjCbNBy4MzhC1Fy_2zeXcJy2Viu8VXdIhmFMyOJKfMoUpL3Qm5WoGIV7QkaStKNnUksfT4-i5U7R80_D2s8OELHQlvdPF1TaR4ZX4zukYOzybAFlP2wxXel8qL0O-S8yBKAuSWv_eDjkGFPWoEjGFGAlAcoKWb7ALN7KBkXvIWTJHAVw0SxFLJWPc7I3qVhL5akySq_1asQ')
    }

    setUserClaims() {
        const admin = new Admin();

        //admin.email = 'ms@pdr.cloud';
        //admin.name = 'Maureen Schwemler';
        //admin.uid = 'HoFQatfpsHcwDQdnuQPnhBOsNIl1';
        //admin.sipgateUserId = 'e24';
        //admin.sipgatePhoneId = 'w19';

        //admin.email = 'libu@pdr.cloud';
        //admin.name = 'Lisa Buss';
        //admin.uid = 'UQoERMrNffUontob7SlPtJfOcIu2';
        //admin.sipgateUserId = 'e28';
        //admin.sipgatePhoneId = 'w20';

        // admin.email = 'hs@pdr.cloud';
        // admin.name = 'Holger Stöckel';
        // admin.uid = 'wkCFH3LZkFOEp6Yuuw9G54UWHGu2';
        // admin.sipgateUserId = 'e33';
        // admin.sipgatePhoneId = 'w22';

        // admin.email = 'am@pdr.cloud';
        // admin.name = 'Alaa Mlaouhi';
        //  admin.uid = 'l4trCHr0IdVqeyeUrbKDeiiIxzF2';
        // admin.email = 'dm@pdr.cloud';
        // admin.name = 'Daria Mousavi';
        //  admin.uid = 'lMPtCqto57ahSsz4sm5FzZrKD3w1';
        // admin.email = 'dh@pdr.cloud';
        // admin.name = 'David Hillmer';
        // admin.uid = 'eO6j77rbSyMrb8HbaPixCHUBuk03';

        // admin.email = 'as@pdr.cloud';
        // admin.name = 'Marc-Andre Schwemler';
        // admin.uid = 'mQlBWJHssrTxL6wUWtBpWTuajA92';
        // admin.sipgateUserId = 'e10';
        // admin.sipgatePhoneId = 'w5';

        // admin.email = 'ns@pdr.cloud';
        // admin.name = 'Nico Söhnlein';
        // admin.uid = 'rCAHYUkwnkStlcnFMJFt89WpWbi2';
        // admin.sipgateUserId = 'e6';
        // admin.sipgatePhoneId = 'w6';

        // admin.email = 'alme@pdr.cloud';
        // admin.name = 'Alexander Meller';
        // admin.uid = 'C5seVkUuPcX1vgPGQuanhonJOWH2';
        // admin.sipgateUserId = 'e13';
        // admin.sipgatePhoneId = 'w8';

        // admin.email = 'mg@pdr.cloud';
        // admin.name = 'Markus Gstalter';
        // admin.uid = 'mRgnSlG643ZBjTCf8ADeLQAOhVA2';
        // admin.sipgateUserId = 'e14';
        // admin.sipgatePhoneId = 'w9';

        // admin.email = 'ou@pdr.cloud';
        // admin.name = 'Oliver Uus';
        // admin.uid = 'u8BsCy3VSXZ0jWTYpSYZ4lmb62h2';
        // admin.sipgateUserId = '';
        // admin.sipgatePhoneId = '';

        // admin.email = 'lb@pdr.cloud';
        // admin.name = 'Linda Boldt';
        // admin.uid = 'fts6Y6NDEwdQlnfwy6TabY9KX0w1';
        // admin.sipgateUserId = 'e15';
        // admin.sipgatePhoneId = 'w10';

        // admin.email = 'jd@pdr.cloud';
        // admin.name = 'John Dedato';
        // admin.uid = 'yd5EIvY2n5NhVOT6EIJLrvbxkZ22';
        // admin.sipgateUserId = 'e16';
        // admin.sipgatePhoneId = 'w11';

        // admin.email = 'an@pdr.cloud';
        // admin.name = 'Arthur Nebe';
        // admin.uid = '8fvmgFqaYYPbAe9pMnQHt3lGm7r2';
        // admin.sipgateUserId = 'e17';
        // admin.sipgatePhoneId = 'w12';

        // admin.email = 'ls@pdr.cloud';
        // admin.name = 'Lara Spiegler';
        // admin.uid = 'K1eAnTcKulgW9ePRiTcaLS4U4aD3';
        // admin.sipgateUserId = 'e18';
        // admin.sipgatePhoneId = 'w13';

        // admin.email = 'en@pdr.cloud';
        // admin.name = 'Erwin Neves';
        // admin.uid = 'EVSERbTNVVRe82OhKYDDogMJEDf2';
        // admin.sipgateUserId = 'e7';
        // admin.sipgatePhoneId = 'w7';
        // admin.email = 'na@pdr.cloud';
        // admin.name = 'Nilgün Altunbas';
        // admin.uid = 'chTbYt0gsRRAQHnds5e1gmk97ks2';
        // admin.sipgateUserId = 'e20';
        // admin.sipgatePhoneId = 'w15';

        // admin.email = 'mk@pdr.cloud';
        // admin.name = 'Marcel Kessler';
        // admin.uid = 'el6p7lwMyBMYp0BtxPLcItiwqeq2';
        // admin.sipgateUserId = 'e23';
        // admin.sipgatePhoneId = 'w18';

        // admin.email = 'ah@pdr.cloud';
        // admin.name = 'Ann-Kathrin Hagenbruch';
        // admin.uid = 'tsjG4JomlDXMS5cPExeDnNr01462';
        // admin.sipgateUserId = 'e22';
        // admin.sipgatePhoneId = 'w17';

        // admin.email = 'jb@pdr.cloud';
        // admin.name = 'Josua Bücher';
        // admin.uid = 'Udthq9t7i4YBlEX2K64ZQr3Oul22';
        // admin.sipgateUserId = 'e0';
        // admin.sipgatePhoneId = 'w0';

        // admin.email = 'fs@pdr.cloud';
        // admin.name = 'Franzi Schick';
        // admin.uid = 'BRWD65yqhEXvnsUJMbd57ltW8AZ2';
        // admin.sipgateUserId = 'e31';
        // admin.sipgatePhoneId = 'w21';

        // admin.email = 'fs@pdr.cloud';
        // admin.name = 'Marius Schantz';
        // admin.uid = '50W2BusTTUcxTlBLUs4UrXKz5bZ2';
        // admin.sipgateUserId = 'e35';
        // admin.sipgatePhoneId = 'w23';

        // admin.email = 'jpm@pdr.cloud';
        // admin.name = 'John-Pierre Mehlhase';
        // admin.uid = 'k35cNJdoAbRG9oEcLBLJF0nWdU23';
        // admin.sipgateUserId = '';
        // admin.sipgatePhoneId = '';

        // admin.email = 'kg@pdr.cloud';
        // admin.name = 'Katharina Giedrojc';
        // admin.uid = 'VG7F9Zjz0vY07Pr9Y3b7PCkG2z83';
        // admin.sipgateUserId = '';
        // admin.sipgatePhoneId = '';

        admin.email = 'fede@pdr.cloud';
        admin.name = 'Felix Dehnert';
        admin.uid = 'sPws8EIwQQflbVgYjcGQ4hYmWXI2';
        admin.sipgateUserId = 'e36';
        admin.sipgatePhoneId = 'w24';

        admin.isSupport = true;
        admin.readClients = true;
        admin.editClients = true;
        admin.editLeads = true;
        admin.readLeads = true;
        admin.readUsers = true;
        admin.readTickets = true;
        admin.editTickets = true;
        // admin.readKnowledge = true;  // Später machen!
        // admin.editKnowledge = true;
        admin.allowLogin = true;
        admin.superAdmin = false;
        admin.allowCalls = true;
        admin.allowCreateAccount = true;

        this.firebaseService.setUserClaims(admin);
    }
    requestImportAllUsers() {
        this.firebaseService.requestImportAllUsers();
    }
    test() {
        this.firebaseService.requestSentTestNotification();
    }
    local() {
        this.firebaseService.localfnc();
    }
    allPhones() {
        this.firebaseService.allPhones();
    }
    importZoho() {
        this.firebaseService.requestImportZoho();
    }
    ngOnInit(): void {}
}
